/* AP — Ziyaretçiyi ülkesine göre pazarına/diline yönlendirir ve SEÇİMİNİ HATIRLAR.
   Ülkeyi Shopify'ın /browsing_context_suggestions.json ucu (IP tabanlı) söyler.
   Kurallar:
   - Ziyaretçi bir pazar/dil adresindeyse (örn. /de-int, /en-us) bu bir SEÇİM sayılır, hatırlanır; sonraki girişlerde ana adrese gelirse oraya götürülür.
   - Dil seçiciyle Türkçeye dönerse (önceki sayfa pazar adresiydi) Türkçe seçimi hatırlanır; bir daha yönlendirilmez.
   - İlk ziyarette yalnız ülke eşleşirse yönlendirilir; eşleşmeyen ülkeler Türkçe sitede kalır.
   - Botlar yönlendirilmez (SEO). ?pazar=tr → Türkçe seçimi. Sepet/ödeme/hesap sayfalarına dokunulmaz. */
(function () {
  'use strict';
  var UA = navigator.userAgent || '';
  if (/bot|crawl|spider|slurp|mediapartners|lighthouse|pagespeed|headless|facebookexternalhit|preview|google-read|bingpreview/i.test(UA)) { return; }
  var yol = location.pathname;
  var ANAHTAR = 'ap_pazar_secim';
  var INT_EN = ['FR', 'ES', 'PL', 'PT', 'SE', 'DK', 'FI', 'NO', 'IE', 'CZ', 'BG', 'HR', 'EE', 'HU', 'LV', 'LT', 'LU', 'MT', 'SK', 'SI'];
  var ONEK = { US: '/en-us', GB: '/en-gb', DE: '/de-int', AT: '/de-int', CH: '/de-int', IT: '/it-int', NL: '/nl-int', BE: '/nl-int', RO: '/ro-int', GR: '/el-int', CY: '/el-int',
               RU: '/ru-int', KZ: '/ru-int', GE: '/ru-int', KG: '/ru-int', AM: '/ru-int' };
  INT_EN.forEach(function (c) { ONEK[c] = '/en-int'; });
  var ONEK_RE = /^\/(en-us|en-gb|(?:en|de|it|nl|ro|el|ru)-int)(?=\/|$)/i;

  function oku() { try { return localStorage.getItem(ANAHTAR) || ''; } catch (e) { return ''; } }
  function yaz(v) { try { localStorage.setItem(ANAHTAR, v); } catch (e) {} }

  if (/[?&]pazar=/.test(location.search)) { yaz('tr'); return; }
  var m = yol.match(ONEK_RE);
  if (m) { yaz('/' + m[1].toLowerCase()); return; }                 // pazar adresindeyse: seçim bu
  if (/^\/(cart|checkout|account|apps|a\/|tools|\.well-known|policies)/i.test(yol)) { return; }
  // Önceki sayfa bizim pazar adresiyse ziyaretçi dil seçiciyle Türkçeye dönmüş demektir → Türkçe seçimi
  try {
    var r = document.referrer ? new URL(document.referrer) : null;
    if (r && r.origin === location.origin && ONEK_RE.test(r.pathname)) { yaz('tr'); return; }
  } catch (e) {}
  var kayitli = oku();
  if (kayitli === 'tr') { return; }
  if (kayitli) { location.replace(kayitli + (yol === '/' ? '' : yol) + location.search + location.hash); return; }
  fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { credentials: 'same-origin' })
    .then(function (resp) { return resp.ok ? resp.json() : null; })
    .then(function (j) {
      if (!j) { return; }
      var ulke = String(((j.detected_values || {}).country || {}).handle || '').toUpperCase();
      var onek = ONEK[ulke];
      if (!onek) { yaz('tr'); return; }
      yaz(onek);
      location.replace(onek + (yol === '/' ? '' : yol) + location.search + location.hash);
    })
    .catch(function () {});
})();
